import { createStore } from "vuex";

export default createStore({
  state: {
    isLoggedIn: JSON.parse(sessionStorage.getItem('isLoggedIn')) || false,
    isLoading: false,
    userToken: sessionStorage.getItem('userToken') || null,
    user: JSON.parse(sessionStorage.getItem('user')),
  },
  getters: {
    isLoggedIn: (state) => {
      return state.isLoggedIn;
    },
    getRole: (state) => {
      return state.user;
    },
    authToken: (state) => {
      return state.userToken;
    },
    loggedUser: (state) => {
      return state.user;
    },
  },
  mutations: {
    LOGIN: function (state) {
      state.isLoading = true;
    },
    LOGIN_SUCCESS: function (state, user) {
      state.isLoggedIn = true;
      state.isLoading = false;
      state.userToken = user.token;
      state.user = user.user;

      // Persist the data in sessionStorage
      sessionStorage.setItem('isLoggedIn', JSON.stringify(state.isLoggedIn));
      sessionStorage.setItem('userToken', state.userToken);
      sessionStorage.setItem('user', JSON.stringify(state.user));
    },
    LOGOUT: function (state) {
      state.isLoggedIn = false;
      state.userToken = null;
      state.user = {};
      sessionStorage.removeItem('isLoggedIn');
      sessionStorage.removeItem('userToken');
      sessionStorage.removeItem('user');
    },
  },
  actions: {
    login: function ({ commit }, user) {
      commit("LOGIN_SUCCESS", user);
    },
    logout: function ({ commit }) {
      commit("LOGOUT");
    },
  },
  modules: {},
});
